// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__m6rfL","selected":"Chip_selected__1kpDf"};